<script setup lang="ts">
import { useAppStore } from '@/app/store/app.store'
import { BulbFilled, BulbOutlined } from '@ant-design/icons-vue'
import { Button, Tooltip } from 'ant-design-vue'

const appStore = useAppStore()
</script>

<template>
 <Tooltip :title="appStore.isDark ? 'Switch to Light mode' : 'Switch to Dark mode'">
  <Button type="text" shape="circle" @click="appStore.toggleTheme()">
   <template #icon>
    <BulbFilled v-if="appStore.isDark" />
    <BulbOutlined v-else />
   </template>
  </Button>
 </Tooltip>
</template>
